// components/MenuItemsTable/index.js
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart } from '@mui/icons-material';

// Import all components
import DishCard from '../Tablemenu/DishCard.jsx';
import CategorySection from '../Tablemenu/CategorySection';
import FilterBar from '../Tablemenu/FilterBar';
import CartSidebar from '../Tablemenu/CartSidebar';
import MobileCartDrawer from '../Tablemenu/MobileCartDrawer';
import AddressPopup from '../Tablemenu/AddressPopup';
import GstPopup from '../Tablemenu/GstPopup';
import ScheduleOrderModal from '../Tablemenu/ScheduleOrderModal';
import InvoicePopup from '../Tablemenu/InvoicePopup';
import Vendorbanner from './Vendorbanner'

const MenuItemsTable = ({ setShowLogin, searchQuery, items,cartData }) => {
  const navigate = useNavigate();

  // State declarations
  const [dishes, setDishes] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isVegSelected, setIsVegSelected] = useState(false);
  const [isNonVegSelected, setIsNonVegSelected] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDish, setSelectedDish] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [description, setDescription] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredDishes, setFilteredDishes] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [isCartPanelOpen, setIsCartPanelOpen] = useState(false);
  const [cartRefresh, setCartRefresh] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [gstTotal, setGstTotal] = useState(0);
  const [platformCharges, setPlatformCharges] = useState(0);
  const [packingCharges, setPackingCharges] = useState(0);
  const [deliveryCharges, setDeliveryCharges] = useState(0);
  const [serviceCharges, setServiceCharges] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [showGstPopup, setShowGstPopup] = useState(false);
  const [gstBreakdownData, setGstBreakdownData] = useState(null);
  const [discountFilter, setDiscountFilter] = useState("Offers");
  const [couponFilter, setCouponFilter] = useState("Coupons");
  const [orderType, setOrderType] = useState("DELIVERY");
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedwalletTypes, setSelectedwalletTypes] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [availableCompany, setAvailableCompany] = useState(0);
  const [availableSelf, setAvailableSelf] = useState(0);
  const [availableCashback, setAvailableCashback] = useState(0);
  const [userProfile, setUserProfile] = useState(null);
  const [orderPlacing, setOrderPlacing] = useState(false);
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const [selectedAddressObj, setSelectedAddressObj] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [address, setAddress] = useState("");
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [scheduledOrderDetails, setScheduledOrderDetails] = useState(null);
  const [completedOrderData, setCompletedOrderData] = useState(null);
  const [isAddressValidForDelivery, setIsAddressValidForDelivery] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(false);
  const [couponId, setCouponId] = useState(null);
  const [parentId, setParentId] = useState(null);
  const [allDishes, setAllDishes] = useState([]);
  const [showInvoicePopup, setShowInvoicePopup] = useState(false);

  const [subCategories, setSubCategories] = useState([]);


  const walletTypesMap = {
    "Self Loaded": "SELF_LOADED",
    "Company Loaded": "COMPANY_LOADED",
    "Cashback": "CASHBACK",
  };

  const getAuthVars = () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");
    const customerId = localStorage.getItem("customerId");
    const cartId = localStorage.getItem("cartId");
    return { userId, token, customerId, cartId };
  };

  // ==================== FETCH WALLET DATA ====================
  const fetchWalletData = async () => {
    const { userId, token } = getAuthVars();
    if (!userId || !token) return;
    try {
      const response = await axios.get(
        `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
        { headers: { Authorization: `Bearer ${token}`, Accept: "*/*", "Content-Type": "application/json" } }
      );
      const data = response.data;
      setAvailableBalance(data.totalBalance || 0);
      setAvailableCompany(data.companyLoadedAmount || 0);
      setAvailableSelf(data.selfLoadedAmount || 0);
      setAvailableCashback(data.cashbackAmount || 0);
    } catch (error) {
      console.error("Wallet API Error:", error);
    }
  };

  // ==================== FETCH ADDRESSES ====================
  const fetchAddresses = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId || !token) return;

    try {
      const response = await axios.get(
        `https://backend.maamaas.com/subscription/api/user/location/${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log("Fetched addresses:", response.data); // Debug log

      const sortedAddresses = (response.data || []).sort((a, b) => {
        const order = { 'Home': 1, 'Office': 2, 'Other': 3 };
        return (order[a.category] || 4) - (order[b.category] || 4);
      });
      setAddresses(sortedAddresses);

      // Check if there's a last used address in localStorage
      const lastAddress = localStorage.getItem("lastDeliveryAddress");
      if (lastAddress && !selectedAddressObj) {
        try {
          const parsed = JSON.parse(lastAddress);
          // Verify that this address still exists in the fetched addresses
          const addressExists = sortedAddresses.some(a => a.id === parsed.id);
          if (addressExists) {
            setSelectedAddressObj(parsed);
            setIsAddressValidForDelivery(true);
            // Also confirm this address with the cart
            await confirmAddress(parsed);
          } else {
            localStorage.removeItem("lastDeliveryAddress");
          }
        } catch (e) {
          console.error("Error parsing last address:", e);
          localStorage.removeItem("lastDeliveryAddress");
        }
      }
    } catch (error) {
      console.error("Failed to fetch addresses", error);
    }
  };

  // ==================== FETCH CART DETAILS ====================
  // const fetchCartDetails = async () => {
  //   const { userId, token } = getAuthVars();
  //   if (!userId) return;
  //   try {
  //     const response = await axios.get(
  //       `https://backend.maamaas.com/food/api/cart/get/user/without-seating?userId=${userId}`,
  //       { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
  //     );
  //     let cartData = response.data;
  //     if (Array.isArray(cartData) && cartData.length > 0) cartData = cartData[0];
  //     if (cartData?.cartId) localStorage.setItem("cartId", cartData.cartId);
  //     const cartItemsList = cartData?.cartItems || [];
  //     setCartItems(cartItemsList);
  //     const initialQuantities = {};
  //     cartItemsList.forEach(item => { initialQuantities[item.itemId] = item.quantity || 1; });
  //     setQuantities(initialQuantities);
  //     setSubTotal(cartData?.subtotal || 0);
  //     setTotal(cartData?.total || 0);
  //     setGstTotal(cartData?.gstTotal || 0);
  //     setPlatformCharges(cartData?.platformCharges || 0);
  //     setServiceCharges(cartData?.serviceCharges || 0);
  //     setPackingCharges(cartData?.packingTotal || 0);
  //     setDeliveryCharges(cartData?.deliveryCharges || 0);
  //     setDiscountAmount(cartData?.discountAmount || 0);
  //     setAppliedCoupon((cartData?.discountAmount || 0) > 0);
  //     setGrandTotal(cartData?.grandTotal || 0);
  //     if (cartData?.orderType) setOrderType(cartData.orderType);
  //   } catch (err) {
  //     console.error("Error fetching cart details:", err);
  //     setCartItems([]);
  //     setQuantities({});
  //   }
  // };


  // ==================== FETCH CART DETAILS ====================
const fetchCartDetails = async () => {
  const { userId, token } = getAuthVars();

  if (!userId || !token) return;

  try {
    const response = await axios.get(
      `https://backend.maamaas.com/food/api/cart/get/user/without-seating?userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    let cartData = response.data;

    if (Array.isArray(cartData)) {
      cartData = cartData[0];
    }

    if (!cartData) {
      setCartItems([]);
      setQuantities({});
      return;
    }

    localStorage.setItem("cartId", cartData.cartId);

    // Save full cart items including addons
    const cartItems = (cartData.cartItems || []).map((item) => ({
      ...item,
      addons: item.addons || [],
    }));

    console.log("Cart Items:", cartItems);

    cartItems.forEach((item) => {
      console.log("Dish:", item.dishName);
      console.log("Addons:", item.addons);
    });

    setCartItems(cartItems);

    const qty = {};

    cartItems.forEach((item) => {
      qty[item.itemId] = item.quantity || 1;
    });

    setQuantities(qty);

    setSubTotal(cartData.subtotal || 0);
    setTotal(cartData.total || 0);
    setGstTotal(cartData.gstTotal || 0);
    setPlatformCharges(cartData.platformCharges || 0);
    setServiceCharges(cartData.serviceCharges || 0);
    setPackingCharges(cartData.packingTotal || 0);
    setDeliveryCharges(cartData.deliveryCharges || 0);
    setDiscountAmount(cartData.discountAmount || 0);
    setAppliedCoupon((cartData.discountAmount || 0) > 0);
    setGrandTotal(cartData.grandTotal || 0);

    if (cartData.orderType) {
      setOrderType(cartData.orderType);
      localStorage.setItem("orderType", cartData.orderType);
    }

    console.log("Cart Loaded", cartData);

  } catch (err) {
    console.log(err);
    setCartItems([]);
    setQuantities({});
  }
};

useEffect(() => {
  // Listen for coupon application events
  const handleCouponApplied = async (event) => {
    if (event.key === 'couponApplied' && event.newValue) {
      console.log("Coupon applied event detected, refreshing cart...");
      await fetchCartDetails();
      setCartRefresh(prev => !prev);
    }
    
    if (event.key === 'couponRemoved') {
      console.log("Coupon removed event detected, refreshing cart...");
      await fetchCartDetails();
      setCartRefresh(prev => !prev);
    }
  };

  window.addEventListener('storage', handleCouponApplied);
  
  return () => {
    window.removeEventListener('storage', handleCouponApplied);
  };
}, []);
  // ==================== ADD TO CART ====================
  // const addToCart = async (item, quantity = 1, isScheduled = false) => {
  //   const { userId, token, customerId } = getAuthVars();
  //   if (!userId) { setShowLogin(true); return; }
  //   if (!token) { toast.error("Please log in to add items to cart."); return; }
  //   try {
  //     const response = await axios.post(
  //       `https://backend.maamaas.com/food/api/cart/add/item?userId=${userId}&customerId=${customerId}&sheduleorder=${isScheduled}`,
  //       { dishId: item?.dishId, quantity },
  //       { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
  //     );
  //     if (response.status === 200 || response.status === 201) {
  //       await fetchCartDetails();
  //       setCartRefresh(prev => !prev);
  //       if (window.innerWidth <= 768) setIsCartPanelOpen(true);
  //       toast.success(`${item.dishName} added to cart!`);
  //     }
  //   } catch (error) {
  //     if (error.response?.status === 401) { toast.error("Session expired. Please login again."); setShowLogin(true); }
  //     else toast.error(error.response?.data?.message || "Failed to add item");
  //   }
  // };

const addToCart = async (
  item,
  quantity = 1,
  isScheduled = false,
  addons = []
) => {

  const { userId, token, customerId } = getAuthVars();

  try {

    const payload = {
      dishId: item.dishId,
      quantity,
      addons: addons.map((a) => ({
        addonId: a.addonId,
        addonName: a.addonName,
        addonPrice: a.addonPrice,
        quantity: 1
      }))
    };

    const { data } = await axios.post(
      `https://backend.maamaas.com/food/api/cart/add/item?userId=${userId}&customerId=${customerId}&sheduleorder=${isScheduled}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log(data);

    await fetchCartDetails();

    toast.success("Added Successfully");

  } catch (err) {

    console.log(err);

    toast.error(err.response?.data?.message);

  }
};

const updateAddonQuantity = async (itemId, addonId, quantity) => {
  const userId = localStorage.getItem("userId");
  const customerId = localStorage.getItem("customerId");
   const token = localStorage.getItem("authToken"); // Your auth token

  try {
    const response = await axios.put(
      "https://backend.maamaas.com/food/api/cart/addon/update",
      null,
      {
        params: {
          userId,
          customerId,
          itemId,
          addonId,
          quantity,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Addon Updated Successfully", response.data);

    // Refresh cart
    fetchCartDetails();
  } catch (error) {
    console.error("Addon update failed:", error.response?.data || error);
  }
};




  // ==================== INCREMENT / DECREMENT ====================
  const incrementQuantity = async (item) => {
    const { userId, token } = getAuthVars();
    if (!item?.itemId) return;
    const newQuantity = (quantities[item.itemId] || item.quantity || 1) + 1;
    try {
      const response = await axios.put(
        `https://backend.maamaas.com/food/api/cart/update/item?userId=${userId}&quantity=${newQuantity}&itemId=${item.itemId}`,
        null,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        setQuantities(prev => ({ ...prev, [item.itemId]: newQuantity }));
        await fetchCartDetails();
      }
    } catch (err) { toast.error("Failed to update quantity"); }
  };

  const decrementQuantity = async (item) => {
    const { userId, token } = getAuthVars();
    if (!item?.itemId) return;
    const currentQty = quantities[item.itemId] || item.quantity || 1;
    if (currentQty === 1) {
      await removeCartItem(item);
      return;
    }
    const newQuantity = currentQty - 1;
    try {
      const response = await axios.put(
        `https://backend.maamaas.com/food/api/cart/update/item?userId=${userId}&quantity=${newQuantity}&itemId=${item.itemId}`,
        null,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        setQuantities(prev => ({ ...prev, [item.itemId]: newQuantity }));
        await fetchCartDetails();
      }
    } catch (err) { toast.error("Failed to update quantity"); }
  };

  const removeCartItem = async (item) => {
    const { userId, token } = getAuthVars();

    if (!item?.itemId) return;

    try {
      const response = await axios.delete(
        `https://backend.maamaas.com/food/api/cart/items/${item.itemId}?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.status === 200) {
        toast.success(`${item.dishName} removed`);

        // clean local state
        setQuantities(prev => {
          const updated = { ...prev };
          delete updated[item.itemId];
          return updated;
        });

        await fetchCartDetails();
      }

    } catch (err) {
      console.error("Delete error:", err);
      toast.error("Failed to remove item");
    }
  };

  // ==================== DISH CARD +/- ====================
  const increaseQuantity = async (dishId, item) => {
    const { userId } = getAuthVars();
    if (!userId) { toast.error("Please log in first."); return; }
    const cartItem = cartItems.find(ci => ci.dishId === dishId);
    if (cartItem) await incrementQuantity(cartItem);
    else await addToCart(item, 1);
  };

  const decreaseQuantity = async (item) => {
    const { userId } = getAuthVars();
    if (!userId || !item.dishId) return;
    const cartItem = cartItems.find(ci => ci.dishId === item.dishId);
    if (cartItem) await decrementQuantity(cartItem);
  };

  // ==================== CLEAR CART ====================
  const handleClearCart = async () => {
    const { userId, token } = getAuthVars();
    if (!userId) { toast.error("User ID not found!"); return; }
    try {
      const response = await axios.delete(
        `https://backend.maamaas.com/food/api/cart/delete/user/cart?userId=${userId}`,
        { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        toast.success("Cart cleared successfully!");
        setCartItems([]);
        setQuantities({});
        setGrandTotal(0);
        setSubTotal(0);
        setGstTotal(0);
        setDiscountAmount(0);
        setAppliedCoupon(false);
        setCouponId(null);
        setShowPaymentOptions(false);
        setSelectedPaymentMethod(null);
        setSelectedwalletTypes(null);
        localStorage.removeItem("cartId");
        await fetchCartDetails();
        if (isMobile) setIsCartPanelOpen(false);
      }
    } catch (error) {
      toast.error("Failed to clear cart");
    }
  };

  // ==================== FAVORITES ====================
  const handleAddToFavorites = async (dishId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId || !token) {
      toast.error("Please log in to add items to favorites.");
      return;
    }

    const dish = dishes.find(d => d.dishId === dishId);
    if (!dish) {
      toast.error(`Dish not found!`);
      return;
    }

    if (favorites.includes(dishId)) {
      toast.success(`❤️ "${dish.dishName}" already in favorites!`);
      return;
    }

    try {
      const response = await fetch(
        `https://backend.maamaas.com/food/api/favourite/add/${userId}/${dishId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const text = await response.text();

      if (response.ok) {
        setFavorites(prev => [...prev, dishId]);
        toast.success(`✅ "${dish.dishName}" added to favorites!`);
      }
      else if (response.status === 409) {
        setFavorites(prev => [...new Set([...prev, dishId])]);
        toast.success(`❤️ Already in favorites!`);
      }
      else {
        console.error("Server Error:", text);
        toast.error("❤️ Already in favorites!");
      }

    } catch (error) {
      console.error("Network error:", error);
      toast.error("❌ Network error.");
    }
  };

  // ==================== TOOLTIP ====================
  const handleToggleTooltip = (dishId, desc) => {
    if (activeTooltip === dishId) {
      setActiveTooltip(null);
      setDescription("");
    } else {
      setActiveTooltip(dishId);
      setDescription(desc || "");
    }
  };

  // ==================== REMOVE COUPON ====================
  const handleRemoveCoupon = async () => {
    try {
      const cartId = localStorage.getItem("cartId");
      const token = localStorage.getItem("authToken");

      if (!cartId || !couponId) {
        toast.error("No applied coupon found!");
        return;
      }

      const body = {
        id: Number(couponId),
        applyCoupon: "NOT_APPLIED"
      };

      const response = await axios.put(
        `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      setAppliedCoupon(false);
      setDiscountAmount(0);
      setCouponId(null);

      await fetchCartDetails();
      toast.success("Coupon removed successfully!");

    } catch (error) {
      console.error("Failed to remove coupon:", error.response?.data || error.message);
      toast.error("Failed to remove coupon");
    }
  };

  // ==================== CONFIRM ADDRESS ====================
  const confirmAddress = async (addr) => {
    try {
      const token = localStorage.getItem("authToken");
      const cartId = localStorage.getItem("cartId");

      if (!cartId) {
        toast.error("Cart not found. Please add items to cart.");
        return;
      }

      const addressId = addr?.id;
      if (!addressId) {
        toast.error("Please select a saved address");
        return;
      }

      console.log("Confirming address with ID:", addressId); // Debug log

      const response = await axios.put(
        `https://backend.maamaas.com/food/api/cart/delivery/${cartId}/address/${addressId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*"
          }
        }
      );

      console.log("Address confirmation response:", response.data); // Debug log

      await fetchCartDetails();
      setIsAddressValidForDelivery(true);
      toast.success("Delivery address selected! You can now proceed to checkout.");

      // Force refresh of cart sidebar
      setCartRefresh(prev => !prev);

    } catch (error) {
      const errorMsg = error.response?.data?.message || error.response?.data || error.message;
      console.error("Failed to assign address:", errorMsg);
      toast.error(errorMsg || "Failed to assign address");
      setIsAddressValidForDelivery(false);
    }
  };

  // ==================== FETCH AND SHOW INVOICE ====================
  const fetchAndShowInvoiceInCart = async (orderId) => {
    try {
      const { token } = getAuthVars();
      if (!token) {
        toast.error("Authentication required");
        return;
      }

      const orderResponse = await axios.get(
        `https://backend.maamaas.com/food/api/orders/order/${orderId}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (orderResponse.status === 200) {
        const orderData = orderResponse.data;
        setCompletedOrderData(orderData);
        setShowInvoicePopup(true); // Show popup instead of showing in cart
        toast.success("Order placed successfully!");
      } else {
        toast.error("Could not fetch order details");
      }
    } catch (error) {
      console.error("Failed to fetch order:", error);
      toast.error("Could not load order details");
    }
  };

  // ==================== RESET AFTER ORDER ====================
  const resetAfterOrder = () => {
    setScheduledOrderDetails(null);
    setScheduleDate("");
    setScheduleTime("");
    setShowPaymentOptions(false);
    setSelectedPaymentMethod(null);
    setSelectedwalletTypes(null);
    setOrderId(null);
    setCompletedOrderData(null);
    setCartItems([]);
    setQuantities({});
    setGrandTotal(0);
    setSubTotal(0);
    localStorage.removeItem("cartId");
    fetchCartDetails();
    fetchWalletData();
    if (isMobile) setIsCartPanelOpen(false);
  };

  // ==================== LOAD RAZORPAY ====================
  const loadRazorpayScript = () => new Promise(resolve => {
    if (window.Razorpay) { resolve(true); return; }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

  // ==================== SCHEDULE ORDER ====================
  const openScheduleModal = () => {
    setIsScheduleModalOpen(true);
  };

  const handleScheduleConfirm = () => {
    if (!scheduleDate || !scheduleTime) {
      toast.error("Please select both date and time");
      return;
    }

    const scheduleDateTime = new Date(`${scheduleDate}T${scheduleTime}`);
    const now = new Date();
    const twoHoursLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);

    if (scheduleDateTime < twoHoursLater) {
      toast.error("Schedule time must be at least 2 hours from now");
      return;
    }

    setScheduledOrderDetails({
      date: scheduleDate,
      time: scheduleTime,
      isScheduled: true
    });

    setIsScheduleModalOpen(false);
    setShowPaymentOptions(true);
    setSelectedPaymentMethod(null);
    setSelectedwalletTypes(null);

    toast.success(`Order scheduled for ${scheduleDate} at ${scheduleTime}`);
  };

  // ==================== CASH PAYMENT ====================
  const handleCashPayment = async (userId, token, cartId) => {
    try {
      let response;

      if (scheduledOrderDetails?.isScheduled) {
        const [hour, minute] = scheduledOrderDetails.time.split(":");

        const schedulePayload = {
          cartId: cartId,
          date: scheduledOrderDetails.date,
          time: {
            hour: parseInt(hour),
            minute: parseInt(minute),
            second: 0,
            nano: 0
          },
          schedule: true,
          paymentMethod: "Cash",
          razorpayPaymentId: "N/A",
          razorpayOrderId: "N/A",
          walletTypes: [],
          totalAmount: grandTotal,
          userId: parseInt(userId)
        };

        response = await axios.post(
          `https://backend.maamaas.com/food/api/orders/shedule/order/${cartId}`,
          schedulePayload,
          {
            params: { userId: parseInt(userId) },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
      } else {
        response = await axios.post(
          `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
          null,
          {
            params: {
              userId: parseInt(userId),
              paymentMethod: "Cash",
              amount: grandTotal
            },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
      }

      const newOrderId = response.data?.orderId;

      if (newOrderId) {
        localStorage.setItem("orderId", newOrderId);
        setOrderId(newOrderId);
        setShowPaymentOptions(false);
        setScheduledOrderDetails(null);
        setScheduleDate("");
        setScheduleTime("");

        await fetchAndShowInvoiceInCart(newOrderId);

        if (scheduledOrderDetails?.isScheduled) {
          toast.success(`✅ Order scheduled for ${scheduledOrderDetails.date} at ${scheduledOrderDetails.time} with Cash on Delivery!`);
        } else {
          toast.success("✅ Order placed successfully!");
        }
      } else {
        throw new Error("No order ID received");
      }

    } catch (error) {
      console.error("Cash Payment Error:", error);
      toast.error(error.response?.data?.message || "Cash payment failed");
      setOrderPlacing(false);
    }
  };

  // ==================== WALLET PAYMENT ====================
  const handleWalletPayment = async (userId, token, cartId) => {
    try {
      if (!selectedwalletTypes) {
        toast.error("Please select a wallet type");
        setOrderPlacing(false);
        return;
      }

      const mappedwalletTypes = walletTypesMap[selectedwalletTypes];
      if (!mappedwalletTypes) {
        toast.error("Invalid wallet type selected");
        setOrderPlacing(false);
        return;
      }

      let availableAmount = 0;
      switch (mappedwalletTypes) {
        case "SELF_LOADED":
          availableAmount = availableSelf;
          break;
        case "COMPANY_LOADED":
          availableAmount = availableCompany;
          break;
        case "CASHBACK":
          availableAmount = availableCashback;
          break;
        default:
          availableAmount = availableBalance;
      }

      if (availableAmount < grandTotal) {
        toast.error(`Insufficient ${selectedwalletTypes} balance. Available: ₹${availableAmount.toFixed(2)}, Required: ₹${grandTotal.toFixed(2)}`);
        setOrderPlacing(false);
        return;
      }

      let response;

      if (scheduledOrderDetails?.isScheduled) {
        const [hour, minute] = scheduledOrderDetails.time.split(":");

        const schedulePayload = {
          cartId: cartId,
          date: scheduledOrderDetails.date,
          time: {
            hour: parseInt(hour),
            minute: parseInt(minute),
            second: 0,
            nano: 0
          },
          schedule: true,
          paymentMethod: "Maamaas_Wallet",
          razorpayPaymentId: "N/A",
          razorpayOrderId: "N/A",
          walletTypes: [mappedwalletTypes],
          totalAmount: grandTotal,
          userId: parseInt(userId)
        };

        response = await axios.post(
          `https://backend.maamaas.com/food/api/orders/shedule/order/${cartId}`,
          schedulePayload,
          {
            params: { userId: parseInt(userId) },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
      } else {
        response = await axios.post(
          `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
          null,
          {
            params: {
              userId: parseInt(userId),
              paymentMethod: "Maamaas_Wallet",
              walletTypes: mappedwalletTypes,
              amount: grandTotal,
              razorpayPaymentId: "N/A",
              razorpayOrderId: "N/A"
            },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
      }

      const newOrderId = response.data?.orderId || response.data?.id;

      if (newOrderId) {
        localStorage.setItem("orderId", newOrderId);
        setOrderId(newOrderId);
        setShowPaymentOptions(false);
        setScheduledOrderDetails(null);
        setScheduleDate("");
        setScheduleTime("");
        await fetchWalletData();

        await fetchAndShowInvoiceInCart(newOrderId);
        toast.success(`✅ Order placed successfully using ${selectedwalletTypes} wallet!`);
      } else {
        throw new Error("No order ID received from server");
      }

    } catch (error) {
      console.error("Wallet Payment Error:", error);
      toast.error(error.response?.data?.message || "Wallet payment failed");
      setOrderPlacing(false);
    }
  };


  const handleOnlinePayment = async (userId, token, cartId) => {
    try {
      setOrderPlacing(true);

      // ✅ STEP 1: CLEAN AMOUNT
      const amount = grandTotal;
      const amountInPaise = grandTotal;

      console.log("Rupees:", amount);
      console.log("Paise:", amountInPaise);

      // ✅ STEP 2: LOAD RAZORPAY
      const isLoaded = await loadRazorpayScript();
      if (!isLoaded) throw new Error("Razorpay SDK failed to load");

      // ✅ STEP 3: CREATE ORDER (SEND PAISE ONLY)
      const orderRes = await axios.post(
        "https://backend.maamaas.com/food/api/payments/create-order/user",
        {
          amount: amountInPaise, // 🔥 FIXED
          currency: "INR",
          receipt: `order_${Date.now()}`,
          userId: parseInt(userId),
          cartId: cartId,
          isScheduled: scheduledOrderDetails?.isScheduled || false,
          scheduleDate: scheduledOrderDetails?.date,
          scheduleTime: scheduledOrderDetails?.time
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      const razorpayOrderId = orderRes.data?.id || orderRes.data?.orderId;
      if (!razorpayOrderId) throw new Error("Failed to create Razorpay order");

      // ✅ STEP 4: RAZORPAY OPTIONS
      const options = {
        key: "rzp_live_RU5whSMu9rPV7s",
        amount: amountInPaise, // 🔥 MUST BE PAISE
        currency: "INR",
        name: "Maamaas Foods",
        description: `Pay ₹${amount.toFixed(2)} for Cart ${cartId}`,
        order_id: razorpayOrderId,

        handler: async function (response) {
          try {
            const {
              razorpay_payment_id: paymentId,
              razorpay_order_id: rzpOrderId,
              razorpay_signature: signature
            } = response;

            // ✅ STEP 5: CAPTURE PAYMENT (PAISE)
            await axios.post(
              "https://backend.maamaas.com/food/api/payments/capture",
              {
                paymentId,
                orderId: rzpOrderId,
                amount: amountInPaise, // 🔥 FIXED
                signature
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json"
                }
              }
            );

            let orderResponse;

            // ✅ STEP 6: CREATE ORDER AFTER PAYMENT
            if (scheduledOrderDetails?.isScheduled) {
              const [hour, minute] = scheduledOrderDetails.time.split(":");

              const scheduleData = {
                cartId: cartId,
                date: scheduledOrderDetails.date,
                time: {
                  hour: parseInt(hour),
                  minute: parseInt(minute),
                  second: 0,
                  nano: 0
                },
                schedule: true,
                paymentMethod: "Online_Payment",
                razorpayPaymentId: paymentId,
                razorpayOrderId: rzpOrderId,
                walletTypes: [],
                totalAmount: amount, // UI/DB RUPEES ok
                userId: parseInt(userId)
              };

              orderResponse = await axios.post(
                `https://backend.maamaas.com/food/api/orders/shedule/order/${cartId}`,
                scheduleData,
                {
                  params: { userId: parseInt(userId) },
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                  }
                }
              );

            } else {
              orderResponse = await axios.post(
                `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
                null,
                {
                  params: {
                    userId: parseInt(userId),
                    paymentMethod: "Online_Payment",
                    amount: amount, // UI OK in rupees
                    razorpayPaymentId: paymentId,
                    razorpayOrderId: rzpOrderId
                  },
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                  }
                }
              );
            }

            const newOrderId = orderResponse.data?.orderId;

            if (newOrderId) {
              localStorage.setItem("orderId", newOrderId);
              setOrderId(newOrderId);

              setShowPaymentOptions(false);
              setScheduledOrderDetails(null);
              setScheduleDate("");
              setScheduleTime("");

              await fetchAndShowInvoiceInCart(newOrderId);

              toast.success(
                `Payment successful! Paid ₹${amount.toFixed(2)}`
              );
            }

          } catch (err) {
            console.error("Payment handler error:", err);
            toast.error("Payment successful but order creation failed.");
          } finally {
            setOrderPlacing(false);
          }
        },

        modal: {
          ondismiss: () => {
            setOrderPlacing(false);
            toast.info("Payment cancelled");
          }
        },

        prefill: {
          name: userProfile?.name || "",
          email: userProfile?.email || "",
          contact: userProfile?.phoneNumber || ""
        },

        theme: { color: "#ee6521" }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (err) {
      console.error("Payment Error:", err);
      toast.error("Payment failed: " + err.message);
      setOrderPlacing(false);
    }
  };

  // ==================== PLACE ORDER ====================
  const handlePlaceOrder = async () => {
    if (orderType === 'DELIVERY' && !selectedAddressObj) {
      toast.error("Please select a delivery address");
      setShowAddressPopup(true);
      setOrderPlacing(false);
      return;
    }

    if (!selectedPaymentMethod) {
      toast.error("Please select a payment method");
      return;
    }
    if (selectedPaymentMethod === "Maamaas_Wallet" && !selectedwalletTypes) {
      toast.error("Please select a wallet type");
      return;
    }

    const { userId, token, cartId } = getAuthVars();
    if (!userId || !token) {
      toast.error("User not logged in. Please login again.");
      return;
    }
    if (!cartId) {
      toast.error("Cart is empty. Please add items to cart.");
      return;
    }
    if (cartItems.length === 0) {
      toast.error("Your cart is empty.");
      return;
    }

    setOrderPlacing(true);
    try {
      if (selectedPaymentMethod === "Online_Payment") {
        await handleOnlinePayment(userId, token, cartId);
      } else if (selectedPaymentMethod === "Maamaas_Wallet") {
        await handleWalletPayment(userId, token, cartId);
      } else if (selectedPaymentMethod === "Cash") {
        await handleCashPayment(userId, token, cartId);
      }
    } catch (error) {
      console.error("Order placement error:", error);
      toast.error(error.response?.data?.message || error.message || "Failed to place order.");
      setOrderPlacing(false);
    }
  };

  // Helper functions for components
  const handleCategorySelect = (cat) => {
    setSelectedCategory(cat.dishId);   // ✅ FIX
    setIsVegSelected(false);
    setIsNonVegSelected(false);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setIsVegSelected(false);
    setIsNonVegSelected(false);
    setSelectedCategory("ALL");
    setDiscountFilter("Offers");
    setCouponFilter("Coupons");
  };

  const handleAddressSelect = async (addr) => {
    console.log("Address selected:", addr); // Debug log

    // Set the selected address object
    setSelectedAddressObj(addr);
    setAddress(addr.address || addr.addressLine || "");

    // Save to localStorage
    localStorage.setItem("lastDeliveryAddress", JSON.stringify(addr));

    // Close the popup
    setShowAddressPopup(false);

    // Confirm the address with the cart
    await confirmAddress(addr);
  };

  const handleAddressAdded = async (newAddress) => {
    console.log("New address added:", newAddress); // Debug log

    if (!newAddress || !newAddress.id) {
      console.error("Invalid new address:", newAddress);
      toast.error("Failed to add address");
      return;
    }

    // Set the selected address object to the new address
    setSelectedAddressObj(newAddress);
    setAddress(newAddress.address || newAddress.addressLine || "");

    // Save to localStorage
    localStorage.setItem("lastDeliveryAddress", JSON.stringify(newAddress));

    // Close the popup
    setShowAddressPopup(false);

    // Wait a bit for state to update then confirm address
    setTimeout(async () => {
      await confirmAddress(newAddress);
    }, 100);
  };
  const handleShowGSTPopup = async () => {
    const { userId, token } = getAuthVars();
    if (!userId || !token) {
      toast.error("Please login to view GST details");
      return;
    }

    try {
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/cart/get/user/without-seating?userId=${userId}`,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );

      const data = response.data;
      let gstData;

      if (Array.isArray(data) && data.length > 0) {
        const firstItem = data[0];
        gstData = {
          serviceChargeGst: firstItem.serviceChargeGst || 0,
          platformChargeGst: firstItem.platformChargeGst || 0,
          cgst: firstItem.cgst || 0,
          sgst: firstItem.sgst || 0,
          gstPercentage: firstItem.gstPercentage || 18
        };
      } else if (data && typeof data === 'object') {
        gstData = {
          serviceChargeGst: data.serviceChargeGst || 0,
          platformChargeGst: data.platformChargeGst || 0,
          cgst: data.cgst || 0,
          sgst: data.sgst || 0,
          gstPercentage: data.gstPercentage || 18
        };
      } else {
        gstData = {
          serviceChargeGst: 0,
          platformChargeGst: 0,
          cgst: 0,
          sgst: 0,
          gstPercentage: 18
        };
      }

      setGstBreakdownData(gstData);
      setShowGstPopup(true);
    } catch (err) {
      console.error("Error fetching GST data:", err);
      toast.error("Failed to fetch GST details");
    }
  };

  const handleApplyCouponWrapper = () => {
    navigate("/Notifications");
  };

  // Window resize handler
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsCartPanelOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch categories
useEffect(() => {
  const fetchSubCategories = async () => {
    const userId = localStorage.getItem("userId");
    const vendorId = localStorage.getItem("vendorId");

    if (!userId || !vendorId) return;

    setCategoriesLoading(true);

    try {
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/dish/getby/vendor/user/dishes?vendorId=${vendorId}&userId=${userId}`
      );

      const data = Array.isArray(response.data) ? response.data : [];

      // Root Categories (parentId = 0)
      const rootCategories = data.filter(
        item => Number(item.parentId) === 0
      );

      // Only Sub Categories
      const subCategoryData = data.filter(item => {
        return rootCategories.some(
          root => Number(root.dishId) === Number(item.parentId)
        );
      });

      console.log("Root Categories", rootCategories);
      console.log("Sub Categories", subCategoryData);

      setSubCategories(subCategoryData);

    } catch (error) {
      console.error(error);
      setSubCategories([]);
    } finally {
      setCategoriesLoading(false);
    }
  };

  fetchSubCategories();
}, []);

  const buildCategoryTree = (data) => {
    const map = new Map();

    data.forEach((item) => {
      const isParent = !item.parentId || item.parentId === 0;

      if (isParent) {
        map.set(item.dishId, {
          ...item,
          subCategories: []
        });
      }
    });

    data.forEach((item) => {
      const isChild = item.parentId && item.parentId !== 0;

      if (isChild && map.has(Number(item.parentId))) {
        map.get(Number(item.parentId)).subCategories.push(item);
      }
    });

    return Array.from(map.values());
  };

  // Fetch dishes
  useEffect(() => {
    const fetchData = async () => {
      const { token, userId } = getAuthVars();
      const vendorId = localStorage.getItem("vendorId");

      if (!vendorId || !token || !userId) {
        setError(new Error("vendorId, userId or authToken missing"));
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `https://backend.maamaas.com/food/api/dish/getby/vendor/user/dishes?vendorId=${vendorId}&userId=${userId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const dishData = Array.isArray(data) ? data : data.data || [];
        setAllDishes(dishData);
        const enabledDishes = dishData.filter(item => item?.menuStatus === "Enable");
        setDishes(enabledDishes);
        setFilteredDishes(enabledDishes);
      } catch (error) {
        console.error(error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    fetchCartDetails();
    fetchWalletData();
  }, [cartRefresh]);

  // Filter effect
  useEffect(() => {
    if (!Array.isArray(allDishes)) return;

    let filtered = [...allDishes];

    // STEP 1: CATEGORY FILTER
    if (selectedCategory && selectedCategory !== "ALL") {
      filtered = filtered.filter(
        item => Number(item.parentId) === Number(selectedCategory)
      );
    }

    // STEP 2: SEARCH FILTER
    const searchValue = searchTerm?.toLowerCase().trim() || "";
    if (searchValue) {
      filtered = filtered.filter(
        item =>
          item?.dishName &&
          item.dishName.toLowerCase().includes(searchValue)
      );
    }

    // STEP 3: VEG / NON-VEG FILTER
    if (isVegSelected) {
      filtered = filtered.filter(item => item?.tag === "Veg");
    } else if (isNonVegSelected) {
      filtered = filtered.filter(item => item?.tag === "Non_Veg");
    }

    // STEP 4: STATUS FILTER
    filtered = filtered.filter(item => item?.menuStatus === "Enable");

    setFilteredDishes(filtered);
    setDishes(filtered);
  }, [
    selectedCategory,
    searchTerm,
    isVegSelected,
    isNonVegSelected,
    allDishes,
    categories
  ]);

  useEffect(() => {
    fetchWalletData();
  }, []);

  useEffect(() => {
    if (showPaymentOptions) {
      fetchWalletData();
    }
  }, [showPaymentOptions]);

  const getTotalItems = () => cartItems.reduce((t, i) => t + (quantities[i.itemId] || i.quantity || 1), 0);
  const cartItemsCount = getTotalItems();

  if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>;
  if (error) return <div style={{ padding: '40px', textAlign: 'center', color: 'red' }}>Error: {error.message}</div>;

  return (



    <div style={{ marginTop: '90px', display: 'flex', gap: '20px' }} className='menuiteams-data'>


      {/* MAIN CONTENT */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <Vendorbanner />
        <FilterBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          isVegSelected={isVegSelected}
          setIsVegSelected={setIsVegSelected}
          isNonVegSelected={isNonVegSelected}
          setIsNonVegSelected={setIsNonVegSelected}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          discountFilter={discountFilter}
          setDiscountFilter={setDiscountFilter}
          couponFilter={couponFilter}
          setCouponFilter={setCouponFilter}
          onClearFilters={clearFilters}
        />

        <CategorySection
          subCategories={subCategories}
          categoriesLoading={categoriesLoading}
          selectedCategory={selectedCategory}
          onCategoryClick={handleCategorySelect}
        />

        <div className="offers-containers" style={{
          padding: '0 16px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
          gap: '20px'
        }}>
          {filteredDishes.map(item => (
            <DishCard
              key={item.dishId}
              item={item}
              cartItems={cartItems}
              quantities={quantities}
              favorites={favorites}
              activeTooltip={activeTooltip}
              onToggleTooltip={handleToggleTooltip}
              onAddToFavorites={handleAddToFavorites}
              onIncreaseQuantity={increaseQuantity}
              onDecreaseQuantity={decreaseQuantity}
              onAddToCart={addToCart}
              getAuthVars={getAuthVars}
              setShowLogin={setShowLogin}
            />
          ))}
        </div>
      </div>

      {/* DESKTOP CART SIDEBAR */}
      {!isMobile && (
        <CartSidebar
  cartItems={cartItems}
  quantities={quantities}
  cartItemsCount={cartItemsCount}
  onClearCart={handleClearCart}
  onDecrementQuantity={decrementQuantity}
  onIncrementQuantity={incrementQuantity}
  subTotal={subTotal}
  gstTotal={gstTotal}
  platformCharges={platformCharges}
  packingCharges={packingCharges}
  deliveryCharges={deliveryCharges}
  discountAmount={discountAmount}
  grandTotal={grandTotal}
  appliedCoupon={appliedCoupon}
  onRemoveCoupon={handleRemoveCoupon}
  onApplyCoupon={handleApplyCouponWrapper}
  orderType={orderType}
  setOrderType={setOrderType}
  selectedAddressObj={selectedAddressObj}
  onShowAddressPopup={setShowAddressPopup}
  showPaymentOptions={showPaymentOptions}
  setShowPaymentOptions={setShowPaymentOptions}
  selectedPaymentMethod={selectedPaymentMethod}
  setSelectedPaymentMethod={setSelectedPaymentMethod}
  selectedwalletTypes={selectedwalletTypes}
  setSelectedwalletTypes={setSelectedwalletTypes}
  onPlaceOrder={handlePlaceOrder}
  orderPlacing={orderPlacing}
  onOpenScheduleModal={openScheduleModal}
  availableBalance={availableBalance}
  availableSelf={availableSelf}
  availableCompany={availableCompany}
  availableCashback={availableCashback}
  onShowGST={handleShowGSTPopup}
  fetchCartData={fetchCartDetails} 
  updateAddonQuantity={updateAddonQuantity} // ✅ Add this
  cartData={{ cartId: localStorage.getItem("cartId") }}  // ✅ Add this
/>
      )}

      {/* MOBILE CART DRAWER */}
      <MobileCartDrawer
        isOpen={isMobile && isCartPanelOpen}
        onClose={() => setIsCartPanelOpen(false)}
        cartItems={cartItems}
        quantities={quantities}
        completedOrderData={completedOrderData}
        cartItemsCount={cartItemsCount}
        onClearCart={handleClearCart}
        onDecrementQuantity={decrementQuantity}
        onIncrementQuantity={incrementQuantity}
        onResetAfterOrder={resetAfterOrder}
        subTotal={subTotal}
        gstTotal={gstTotal}
        platformCharges={platformCharges}
        packingCharges={packingCharges}
        deliveryCharges={deliveryCharges}
        discountAmount={discountAmount}
        grandTotal={grandTotal}
        appliedCoupon={appliedCoupon}
        onRemoveCoupon={handleRemoveCoupon}
        onApplyCoupon={handleApplyCouponWrapper}
        orderType={orderType}
        setOrderType={setOrderType}
        selectedAddressObj={selectedAddressObj}
        onShowAddressPopup={setShowAddressPopup}
        showPaymentOptions={showPaymentOptions}
        setShowPaymentOptions={setShowPaymentOptions}
        selectedPaymentMethod={selectedPaymentMethod}
        setSelectedPaymentMethod={setSelectedPaymentMethod}
        selectedwalletTypes={selectedwalletTypes}
        setSelectedwalletTypes={setSelectedwalletTypes}
        onPlaceOrder={handlePlaceOrder}
        orderPlacing={orderPlacing}
        onOpenScheduleModal={openScheduleModal}
        availableBalance={availableBalance}
        availableSelf={availableSelf}
        availableCompany={availableCompany}
        availableCashback={availableCashback}
        onShowGST={handleShowGSTPopup}
      />

      {/* FLOATING CART BUTTON FOR MOBILE */}
      {isMobile && cartItemsCount > 0 && !completedOrderData && (
        <button
          onClick={() => setIsCartPanelOpen(true)}
          style={{
            position: 'fixed',
            bottom: '80px',
            right: '20px',
            background: '#ee6521',
            color: '#fff',
            border: 'none',
            borderRadius: '50px',
            padding: '14px 24px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            zIndex: 100,
            boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold'
          }}
        >
          <ShoppingCart />
          <span>{cartItemsCount}</span>
        </button>
      )}

      {/* MODALS */}
      <AddressPopup
        isOpen={showAddressPopup}
        onClose={() => setShowAddressPopup(false)}
        addresses={addresses}
        selectedAddressObj={selectedAddressObj}
        onAddressSelect={handleAddressSelect}
        onAddressAdded={handleAddressAdded}
        fetchAddresses={fetchAddresses}
      />

      <GstPopup
        isOpen={showGstPopup}
        onClose={() => setShowGstPopup(false)}
        gstBreakdownData={gstBreakdownData}
      />

      <ScheduleOrderModal
        isOpen={isScheduleModalOpen}
        onClose={() => {
          setIsScheduleModalOpen(false);
          setScheduleDate("");
          setScheduleTime("");
        }}
        scheduleDate={scheduleDate}
        setScheduleDate={setScheduleDate}
        scheduleTime={scheduleTime}
        setScheduleTime={setScheduleTime}
        onConfirm={handleScheduleConfirm}
      />

      <InvoicePopup
        isOpen={showInvoicePopup}
        onClose={() => {
          setShowInvoicePopup(false);
          resetAfterOrder();
        }}
        orderData={completedOrderData}
      />

      <style>{`
        @media (max-width: 768px) { 
          .offers-containers { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; } 
        }
        @media (max-width: 480px) { 
          .offers-containers { grid-template-columns: repeat(1, 1fr) !important; } 
        }
      `}</style>
    </div>

  );
};

export default MenuItemsTable;







// import React, { useEffect, useState, useRef } from 'react';
// import axios from 'axios';
// import toast from 'react-hot-toast';
// import { useNavigate } from 'react-router-dom';
// import { ShoppingCart } from '@mui/icons-material';

// // Import all components
// import DishCard from '../Tablemenu/DishCard.jsx';
// import CategorySection from '../Tablemenu/CategorySection';
// import FilterBar from '../Tablemenu/FilterBar';
// import CartSidebar from '../Tablemenu/CartSidebar';
// import MobileCartDrawer from '../Tablemenu/MobileCartDrawer';
// import AddressPopup from '../Tablemenu/AddressPopup';
// import GstPopup from '../Tablemenu/GstPopup';
// import ScheduleOrderModal from '../Tablemenu/ScheduleOrderModal';
// import InvoicePopup from '../Tablemenu/InvoicePopup';
// import Vendorbanner from './Vendorbanner'

// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Checkbox,
//   FormControlLabel,
// } from "@mui/material";

// const MenuItemsTable = ({ setShowLogin, searchQuery, items,cartData }) => {
//   const navigate = useNavigate();

//   // State declarations
//   const [dishes, setDishes] = useState([]);
//   const [quantities, setQuantities] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isVegSelected, setIsVegSelected] = useState(false);
//   const [isNonVegSelected, setIsNonVegSelected] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedDish, setSelectedDish] = useState(null);
//   const [cartItems, setCartItems] = useState([]);
//   const [activeTooltip, setActiveTooltip] = useState(null);
//   const [description, setDescription] = useState("");
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredDishes, setFilteredDishes] = useState([]);
//   const [favorites, setFavorites] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [categoriesLoading, setCategoriesLoading] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState("ALL");
//   const [isCartPanelOpen, setIsCartPanelOpen] = useState(false);
//   const [cartRefresh, setCartRefresh] = useState(false);
//   const [subTotal, setSubTotal] = useState(0);
//   const [total, setTotal] = useState(0);
//   const [gstTotal, setGstTotal] = useState(0);
//   const [platformCharges, setPlatformCharges] = useState(0);
//   const [packingCharges, setPackingCharges] = useState(0);
//   const [deliveryCharges, setDeliveryCharges] = useState(0);
//   const [serviceCharges, setServiceCharges] = useState(0);
//   const [discountAmount, setDiscountAmount] = useState(0);
//   const [grandTotal, setGrandTotal] = useState(0);
//   const [showGstPopup, setShowGstPopup] = useState(false);
//   const [gstBreakdownData, setGstBreakdownData] = useState(null);
//   const [discountFilter, setDiscountFilter] = useState("Offers");
//   const [couponFilter, setCouponFilter] = useState("Coupons");
//   const [orderType, setOrderType] = useState("DELIVERY");
//   const [showPaymentOptions, setShowPaymentOptions] = useState(false);
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
//   const [selectedwalletTypes, setSelectedwalletTypes] = useState(null);
//   const [orderId, setOrderId] = useState(null);
//   const [availableBalance, setAvailableBalance] = useState(0);
//   const [availableCompany, setAvailableCompany] = useState(0);
//   const [availableSelf, setAvailableSelf] = useState(0);
//   const [availableCashback, setAvailableCashback] = useState(0);
//   const [userProfile, setUserProfile] = useState(null);
//   const [orderPlacing, setOrderPlacing] = useState(false);
//   const [showAddressPopup, setShowAddressPopup] = useState(false);
//   const [selectedAddressObj, setSelectedAddressObj] = useState(null);
//   const [addresses, setAddresses] = useState([]);
//   const [address, setAddress] = useState("");
//   const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
//   const [scheduleDate, setScheduleDate] = useState("");
//   const [scheduleTime, setScheduleTime] = useState("");
//   const [scheduledOrderDetails, setScheduledOrderDetails] = useState(null);
//   const [completedOrderData, setCompletedOrderData] = useState(null);
//   const [isAddressValidForDelivery, setIsAddressValidForDelivery] = useState(false);
//   const [appliedCoupon, setAppliedCoupon] = useState(false);
//   const [couponId, setCouponId] = useState(null);
//   const [parentId, setParentId] = useState(null);
//   const [allDishes, setAllDishes] = useState([]);
//   const [showInvoicePopup, setShowInvoicePopup] = useState(false);

//   const [subCategories, setSubCategories] = useState([]);


// const [selectedAddons, setSelectedAddons] = useState([]);
// const [openAddonPopup, setOpenAddonPopup] = useState(false);
// // const [updateAddonQuantity, setupdateAddonQuantity] = useState({});



// const handleOpenAddon = (dish) => {
//   setSelectedDish(dish);
//   setSelectedAddons([]);
//   setOpenAddonPopup(true);
// };


//   const walletTypesMap = {
//     "Self Loaded": "SELF_LOADED",
//     "Company Loaded": "COMPANY_LOADED",
//     "Cashback": "CASHBACK",
//   };

//   const getAuthVars = () => {
//     const userId = localStorage.getItem("userId");
//     const token = localStorage.getItem("authToken");
//     const customerId = localStorage.getItem("customerId");
//     const cartId = localStorage.getItem("cartId");
//     return { userId, token, customerId, cartId };
//   };

//   // ==================== FETCH WALLET DATA ====================
//   const fetchWalletData = async () => {
//     const { userId, token } = getAuthVars();
//     if (!userId || !token) return;
//     try {
//       const response = await axios.get(
//         `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
//         { headers: { Authorization: `Bearer ${token}`, Accept: "*/*", "Content-Type": "application/json" } }
//       );
//       const data = response.data;
//       setAvailableBalance(data.totalBalance || 0);
//       setAvailableCompany(data.companyLoadedAmount || 0);
//       setAvailableSelf(data.selfLoadedAmount || 0);
//       setAvailableCashback(data.cashbackAmount || 0);
//     } catch (error) {
//       console.error("Wallet API Error:", error);
//     }
//   };

//   // ==================== FETCH ADDRESSES ====================
//   const fetchAddresses = async () => {
//     const userId = localStorage.getItem("userId");
//     const token = localStorage.getItem("authToken");

//     if (!userId || !token) return;

//     try {
//       const response = await axios.get(
//         `https://backend.maamaas.com/subscription/api/user/location/${userId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       console.log("Fetched addresses:", response.data); // Debug log

//       const sortedAddresses = (response.data || []).sort((a, b) => {
//         const order = { 'Home': 1, 'Office': 2, 'Other': 3 };
//         return (order[a.category] || 4) - (order[b.category] || 4);
//       });
//       setAddresses(sortedAddresses);

//       // Check if there's a last used address in localStorage
//       const lastAddress = localStorage.getItem("lastDeliveryAddress");
//       if (lastAddress && !selectedAddressObj) {
//         try {
//           const parsed = JSON.parse(lastAddress);
//           // Verify that this address still exists in the fetched addresses
//           const addressExists = sortedAddresses.some(a => a.id === parsed.id);
//           if (addressExists) {
//             setSelectedAddressObj(parsed);
//             setIsAddressValidForDelivery(true);
//             // Also confirm this address with the cart
//             await confirmAddress(parsed);
//           } else {
//             localStorage.removeItem("lastDeliveryAddress");
//           }
//         } catch (e) {
//           console.error("Error parsing last address:", e);
//           localStorage.removeItem("lastDeliveryAddress");
//         }
//       }
//     } catch (error) {
//       console.error("Failed to fetch addresses", error);
//     }
//   };

//   // ==================== FETCH CART DETAILS ====================
//   // const fetchCartDetails = async () => {
//   //   const { userId, token } = getAuthVars();
//   //   if (!userId) return;
//   //   try {
//   //     const response = await axios.get(
//   //       `https://backend.maamaas.com/food/api/cart/get/user/without-seating?userId=${userId}`,
//   //       { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
//   //     );
//   //     let cartData = response.data;
//   //     if (Array.isArray(cartData) && cartData.length > 0) cartData = cartData[0];
//   //     if (cartData?.cartId) localStorage.setItem("cartId", cartData.cartId);
//   //     const cartItemsList = cartData?.cartItems || [];
//   //     setCartItems(cartItemsList);
//   //     const initialQuantities = {};
//   //     cartItemsList.forEach(item => { initialQuantities[item.itemId] = item.quantity || 1; });
//   //     setQuantities(initialQuantities);
//   //     setSubTotal(cartData?.subtotal || 0);
//   //     setTotal(cartData?.total || 0);
//   //     setGstTotal(cartData?.gstTotal || 0);
//   //     setPlatformCharges(cartData?.platformCharges || 0);
//   //     setServiceCharges(cartData?.serviceCharges || 0);
//   //     setPackingCharges(cartData?.packingTotal || 0);
//   //     setDeliveryCharges(cartData?.deliveryCharges || 0);
//   //     setDiscountAmount(cartData?.discountAmount || 0);
//   //     setAppliedCoupon((cartData?.discountAmount || 0) > 0);
//   //     setGrandTotal(cartData?.grandTotal || 0);
//   //     if (cartData?.orderType) setOrderType(cartData.orderType);
//   //   } catch (err) {
//   //     console.error("Error fetching cart details:", err);
//   //     setCartItems([]);
//   //     setQuantities({});
//   //   }
//   // };


//   // ==================== FETCH CART DETAILS ====================
// const fetchCartDetails = async () => {
//   const { userId, token } = getAuthVars();

//   if (!userId || !token) return;

//   try {
//     const { data } = await axios.get(
//       `https://backend.maamaas.com/food/api/cart/get/user/without-seating?userId=${userId}`,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     const cart = Array.isArray(data) ? data[0] : data;

//     console.log("FULL CART");
//     console.log(cart);

//     console.log("CART ITEMS");
//     console.table(cart.cartItems);

//     cart.cartItems.forEach((item) => {
//       console.log("ItemId :", item.itemId);

//       console.table(item.addons);
//     });

//     localStorage.setItem("cartId", cart.cartId);

//     setCartItems(cart.cartItems || []);

//     const qty = {};

//     (cart.cartItems || []).forEach((i) => {
//       qty[i.itemId] = i.quantity;
//     });

//     setQuantities(qty);

//     setSubTotal(cart.subtotal || 0);
//     setGstTotal(cart.gstTotal || 0);
//     setPackingCharges(cart.packingTotal || 0);
//     setPlatformCharges(cart.platformCharges || 0);
//     setDeliveryCharges(cart.deliveryCharges || 0);
//     setDiscountAmount(cart.discountAmount || 0);
//     setGrandTotal(cart.grandTotal || 0);

//   } catch (err) {
//     console.log(err);
//   }
// };

// useEffect(() => {
//   // Listen for coupon application events
//   const handleCouponApplied = async (event) => {
//     if (event.key === 'couponApplied' && event.newValue) {
//       console.log("Coupon applied event detected, refreshing cart...");
//       await fetchCartDetails();
//       setCartRefresh(prev => !prev);
//     }
    
//     if (event.key === 'couponRemoved') {
//       console.log("Coupon removed event detected, refreshing cart...");
//       await fetchCartDetails();
//       setCartRefresh(prev => !prev);
//     }
//   };

//   window.addEventListener('storage', handleCouponApplied);
  
//   return () => {
//     window.removeEventListener('storage', handleCouponApplied);
//   };
// }, []);
  

// // const addToCart = async (item, quantity = 1, isScheduled = false) => {
// //   const { userId, token, customerId } = getAuthVars();
// //   if (!userId) { setShowLogin(true); return; }
// //   if (!token) { toast.error("Please log in to add items to cart."); return; }
  
// //   try {
// //     const response = await axios.post(
// //       `https://backend.maamaas.com/food/api/cart/add/item?userId=${userId}&customerId=${customerId}&sheduleorder=${isScheduled}`,
// //       { dishId: item?.dishId, quantity },
// //       { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
// //     );
    
// //     console.log("Add to cart response:", response.data);
    
// //     if (response.status === 200 || response.status === 201) {
// //       // ✅ First, try to get cartId from response
// //       const cartId = response.data?.cartId || response.data?.data?.cartId;
// //       if (cartId) {
// //         localStorage.setItem("cartId", cartId);
// //         console.log("CartId saved from response:", cartId);
// //       }
      
// //       // ✅ Then fetch full cart details (this will also save cartId)
// //       await fetchCartDetails();
      
// //       setCartRefresh(prev => !prev);
// //       if (window.innerWidth <= 768) setIsCartPanelOpen(true);
// //       toast.success(`${item.dishName} added to cart!`);
// //     }
// //   } catch (error) {
// //     console.error("Add to cart error:", error);
// //     if (error.response?.status === 401) { 
// //       toast.error("Session expired. Please login again."); 
// //       setShowLogin(true); 
// //     } else {
// //       toast.error(error.response?.data?.message || "Failed to add item");
// //     }
// //   }
// // };



// const addToCart = async (
//   item,
//   quantity = 1,
//   isScheduled = false,
//   addons = []
// ) => {

//   const { userId, token, customerId } = getAuthVars();

//   try {

//     const payload = {
//       dishId: item.dishId,
//       quantity,
//       addons: addons.map((a) => ({
//         addonId: a.addonId,
//         addonName: a.addonName,
//         addonPrice: a.addonPrice,
//         quantity: 1
//       }))
//     };

//     const { data } = await axios.post(
//       `https://backend.maamaas.com/food/api/cart/add/item?userId=${userId}&customerId=${customerId}&sheduleorder=${isScheduled}`,
//       payload,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     console.log(data);

//     await fetchCartDetails();

//     toast.success("Added Successfully");

//   } catch (err) {

//     console.log(err);

//     toast.error(err.response?.data?.message);

//   }
// };

// const updateAddonQuantity = async (itemId, addonId, quantity) => {

//     const userId = localStorage.getItem("userId");
//     const customerId = localStorage.getItem("customerId");
//     const token = localStorage.getItem("authToken");

//     console.log("========= UPDATE ADDON =========");

//     console.log({
//         userId,
//         customerId,
//         token,
//         itemId,
//         addonId,
//         quantity
//     });

//     const url =
// `https://backend.maamaas.com/food/api/cart/addon/update?userId=${userId}&customerId=${customerId}&itemId=${itemId}&addonId=${addonId}&quantity=${quantity}`;

//     console.log(url);

//     try {

//         const res = await axios.post(
//             url,
//             {},
//             {
//                 headers:{
//                     Authorization:`Bearer ${token}`
//                 }
//             }
//         );

//         console.log("SUCCESS");
//         console.log(res.data);

//         fetchCartDetails();

//     } catch(err){

//         console.log("STATUS");
//         console.log(err.response?.status);

//         console.log("DATA");
//         console.log(err.response?.data);

//         console.log("MESSAGE");
//         console.log(err.response?.data?.message);

//     }

// };




//   // ==================== INCREMENT / DECREMENT ====================
//   const incrementQuantity = async (item) => {
//     const { userId, token } = getAuthVars();
//     if (!item?.itemId) return;
//     const newQuantity = (quantities[item.itemId] || item.quantity || 1) + 1;
//     try {
//       const response = await axios.put(
//         `https://backend.maamaas.com/food/api/cart/update/item?userId=${userId}&quantity=${newQuantity}&itemId=${item.itemId}`,
//         null,
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
//       );
//       if (response.status === 200) {
//         setQuantities(prev => ({ ...prev, [item.itemId]: newQuantity }));
//         await fetchCartDetails();
//       }
//     } catch (err) { toast.error("Failed to update quantity"); }
//   };

//   const decrementQuantity = async (item) => {
//     const { userId, token } = getAuthVars();
//     if (!item?.itemId) return;
//     const currentQty = quantities[item.itemId] || item.quantity || 1;
//     if (currentQty === 1) {
//       await removeCartItem(item);
//       return;
//     }
//     const newQuantity = currentQty - 1;
//     try {
//       const response = await axios.put(
//         `https://backend.maamaas.com/food/api/cart/update/item?userId=${userId}&quantity=${newQuantity}&itemId=${item.itemId}`,
//         null,
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
//       );
//       if (response.status === 200) {
//         setQuantities(prev => ({ ...prev, [item.itemId]: newQuantity }));
//         await fetchCartDetails();
//       }
//     } catch (err) { toast.error("Failed to update quantity"); }
//   };

//   const removeCartItem = async (item) => {
//     const { userId, token } = getAuthVars();

//     if (!item?.itemId) return;

//     try {
//       const response = await axios.delete(
//         `https://backend.maamaas.com/food/api/cart/items/${item.itemId}?userId=${userId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json"
//           }
//         }
//       );

//       if (response.status === 200) {
//         toast.success(`${item.dishName} removed`);

//         // clean local state
//         setQuantities(prev => {
//           const updated = { ...prev };
//           delete updated[item.itemId];
//           return updated;
//         });

//         await fetchCartDetails();
//       }

//     } catch (err) {
//       console.error("Delete error:", err);
//       toast.error("Failed to remove item");
//     }
//   };

//   // ==================== DISH CARD +/- ====================
//   const increaseQuantity = async (dishId, item) => {
//     const { userId } = getAuthVars();
//     if (!userId) { toast.error("Please log in first."); return; }
//     const cartItem = cartItems.find(ci => ci.dishId === dishId);
//     if (cartItem) await incrementQuantity(cartItem);
//     else await addToCart(item, 1);
//   };

//   const decreaseQuantity = async (item) => {
//     const { userId } = getAuthVars();
//     if (!userId || !item.dishId) return;
//     const cartItem = cartItems.find(ci => ci.dishId === item.dishId);
//     if (cartItem) await decrementQuantity(cartItem);
//   };

//   // ==================== CLEAR CART ====================
//   const handleClearCart = async () => {
//     const { userId, token } = getAuthVars();
//     if (!userId) { toast.error("User ID not found!"); return; }
//     try {
//       const response = await axios.delete(
//         `https://backend.maamaas.com/food/api/cart/delete/user/cart?userId=${userId}`,
//         { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
//       );
//       if (response.status === 200) {
//         toast.success("Cart cleared successfully!");
//         setCartItems([]);
//         setQuantities({});
//         setGrandTotal(0);
//         setSubTotal(0);
//         setGstTotal(0);
//         setDiscountAmount(0);
//         setAppliedCoupon(false);
//         setCouponId(null);
//         setShowPaymentOptions(false);
//         setSelectedPaymentMethod(null);
//         setSelectedwalletTypes(null);
//         localStorage.removeItem("cartId");
//         await fetchCartDetails();
//         if (isMobile) setIsCartPanelOpen(false);
//       }
//     } catch (error) {
//       toast.error("Failed to clear cart");
//     }
//   };

//   // ==================== FAVORITES ====================
//   const handleAddToFavorites = async (dishId) => {
//     const userId = localStorage.getItem("userId");
//     const token = localStorage.getItem("authToken");

//     if (!userId || !token) {
//       toast.error("Please log in to add items to favorites.");
//       return;
//     }

//     const dish = dishes.find(d => d.dishId === dishId);
//     if (!dish) {
//       toast.error(`Dish not found!`);
//       return;
//     }

//     if (favorites.includes(dishId)) {
//       toast.success(`❤️ "${dish.dishName}" already in favorites!`);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `https://backend.maamaas.com/food/api/favourite/add/${userId}/${dishId}`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const text = await response.text();

//       if (response.ok) {
//         setFavorites(prev => [...prev, dishId]);
//         toast.success(`✅ "${dish.dishName}" added to favorites!`);
//       }
//       else if (response.status === 409) {
//         setFavorites(prev => [...new Set([...prev, dishId])]);
//         toast.success(`❤️ Already in favorites!`);
//       }
//       else {
//         console.error("Server Error:", text);
//         toast.error("❤️ Already in favorites!");
//       }

//     } catch (error) {
//       console.error("Network error:", error);
//       toast.error("❌ Network error.");
//     }
//   };

//   // ==================== TOOLTIP ====================
//   const handleToggleTooltip = (dishId, desc) => {
//     if (activeTooltip === dishId) {
//       setActiveTooltip(null);
//       setDescription("");
//     } else {
//       setActiveTooltip(dishId);
//       setDescription(desc || "");
//     }
//   };

//   // ==================== REMOVE COUPON ====================
//   const handleRemoveCoupon = async () => {
//     try {
//       const cartId = localStorage.getItem("cartId");
//       const token = localStorage.getItem("authToken");

//       if (!cartId || !couponId) {
//         toast.error("No applied coupon found!");
//         return;
//       }

//       const body = {
//         id: Number(couponId),
//         applyCoupon: "NOT_APPLIED"
//       };

//       const response = await axios.put(
//         `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
//         body,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json"
//           }
//         }
//       );

//       setAppliedCoupon(false);
//       setDiscountAmount(0);
//       setCouponId(null);

//       await fetchCartDetails();
//       toast.success("Coupon removed successfully!");

//     } catch (error) {
//       console.error("Failed to remove coupon:", error.response?.data || error.message);
//       toast.error("Failed to remove coupon");
//     }
//   };

//   // ==================== CONFIRM ADDRESS ====================
//   const confirmAddress = async (addr) => {
//     try {
//       const token = localStorage.getItem("authToken");
//       const cartId = localStorage.getItem("cartId");

//       if (!cartId) {
//         toast.error("Cart not found. Please add items to cart.");
//         return;
//       }

//       const addressId = addr?.id;
//       if (!addressId) {
//         toast.error("Please select a saved address");
//         return;
//       }

//       console.log("Confirming address with ID:", addressId); // Debug log

//       const response = await axios.put(
//         `https://backend.maamaas.com/food/api/cart/delivery/${cartId}/address/${addressId}`,
//         null,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "*/*"
//           }
//         }
//       );

//       console.log("Address confirmation response:", response.data); // Debug log

//       await fetchCartDetails();
//       setIsAddressValidForDelivery(true);
//       toast.success("Delivery address selected! You can now proceed to checkout.");

//       // Force refresh of cart sidebar
//       setCartRefresh(prev => !prev);

//     } catch (error) {
//       const errorMsg = error.response?.data?.message || error.response?.data || error.message;
//       console.error("Failed to assign address:", errorMsg);
//       toast.error(errorMsg || "Failed to assign address");
//       setIsAddressValidForDelivery(false);
//     }
//   };

//   // ==================== FETCH AND SHOW INVOICE ====================
//   const fetchAndShowInvoiceInCart = async (orderId) => {
//     try {
//       const { token } = getAuthVars();
//       if (!token) {
//         toast.error("Authentication required");
//         return;
//       }

//       const orderResponse = await axios.get(
//         `https://backend.maamaas.com/food/api/orders/order/${orderId}`,
//         {
//           headers: {
//             "Authorization": `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (orderResponse.status === 200) {
//         const orderData = orderResponse.data;
//         setCompletedOrderData(orderData);
//         setShowInvoicePopup(true); // Show popup instead of showing in cart
//         toast.success("Order placed successfully!");
//       } else {
//         toast.error("Could not fetch order details");
//       }
//     } catch (error) {
//       console.error("Failed to fetch order:", error);
//       toast.error("Could not load order details");
//     }
//   };

//   // ==================== RESET AFTER ORDER ====================
//   const resetAfterOrder = () => {
//     setScheduledOrderDetails(null);
//     setScheduleDate("");
//     setScheduleTime("");
//     setShowPaymentOptions(false);
//     setSelectedPaymentMethod(null);
//     setSelectedwalletTypes(null);
//     setOrderId(null);
//     setCompletedOrderData(null);
//     setCartItems([]);
//     setQuantities({});
//     setGrandTotal(0);
//     setSubTotal(0);
//     localStorage.removeItem("cartId");
//     fetchCartDetails();
//     fetchWalletData();
//     if (isMobile) setIsCartPanelOpen(false);
//   };

//   // ==================== LOAD RAZORPAY ====================
//   const loadRazorpayScript = () => new Promise(resolve => {
//     if (window.Razorpay) { resolve(true); return; }
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.onload = () => resolve(true);
//     script.onerror = () => resolve(false);
//     document.body.appendChild(script);
//   });

//   // ==================== SCHEDULE ORDER ====================
//   const openScheduleModal = () => {
//     setIsScheduleModalOpen(true);
//   };

//   const handleScheduleConfirm = () => {
//     if (!scheduleDate || !scheduleTime) {
//       toast.error("Please select both date and time");
//       return;
//     }

//     const scheduleDateTime = new Date(`${scheduleDate}T${scheduleTime}`);
//     const now = new Date();
//     const twoHoursLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);

//     if (scheduleDateTime < twoHoursLater) {
//       toast.error("Schedule time must be at least 2 hours from now");
//       return;
//     }

//     setScheduledOrderDetails({
//       date: scheduleDate,
//       time: scheduleTime,
//       isScheduled: true
//     });

//     setIsScheduleModalOpen(false);
//     setShowPaymentOptions(true);
//     setSelectedPaymentMethod(null);
//     setSelectedwalletTypes(null);

//     toast.success(`Order scheduled for ${scheduleDate} at ${scheduleTime}`);
//   };

//   // ==================== CASH PAYMENT ====================
//   const handleCashPayment = async (userId, token, cartId) => {
//     try {
//       let response;

//       if (scheduledOrderDetails?.isScheduled) {
//         const [hour, minute] = scheduledOrderDetails.time.split(":");

//         const schedulePayload = {
//           cartId: cartId,
//           date: scheduledOrderDetails.date,
//           time: {
//             hour: parseInt(hour),
//             minute: parseInt(minute),
//             second: 0,
//             nano: 0
//           },
//           schedule: true,
//           paymentMethod: "Cash",
//           razorpayPaymentId: "N/A",
//           razorpayOrderId: "N/A",
//           walletTypes: [],
//           totalAmount: grandTotal,
//           userId: parseInt(userId)
//         };

//         response = await axios.post(
//           `https://backend.maamaas.com/food/api/orders/shedule/order/${cartId}`,
//           schedulePayload,
//           {
//             params: { userId: parseInt(userId) },
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json"
//             }
//           }
//         );
//       } else {
//         response = await axios.post(
//           `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
//           null,
//           {
//             params: {
//               userId: parseInt(userId),
//               paymentMethod: "Cash",
//               amount: grandTotal
//             },
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json"
//             }
//           }
//         );
//       }

//       const newOrderId = response.data?.orderId;

//       if (newOrderId) {
//         localStorage.setItem("orderId", newOrderId);
//         setOrderId(newOrderId);
//         setShowPaymentOptions(false);
//         setScheduledOrderDetails(null);
//         setScheduleDate("");
//         setScheduleTime("");

//         await fetchAndShowInvoiceInCart(newOrderId);

//         if (scheduledOrderDetails?.isScheduled) {
//           toast.success(`✅ Order scheduled for ${scheduledOrderDetails.date} at ${scheduledOrderDetails.time} with Cash on Delivery!`);
//         } else {
//           toast.success("✅ Order placed successfully!");
//         }
//       } else {
//         throw new Error("No order ID received");
//       }

//     } catch (error) {
//       console.error("Cash Payment Error:", error);
//       toast.error(error.response?.data?.message || "Cash payment failed");
//       setOrderPlacing(false);
//     }
//   };

//   // ==================== WALLET PAYMENT ====================
//   const handleWalletPayment = async (userId, token, cartId) => {
//     try {
//       if (!selectedwalletTypes) {
//         toast.error("Please select a wallet type");
//         setOrderPlacing(false);
//         return;
//       }

//       const mappedwalletTypes = walletTypesMap[selectedwalletTypes];
//       if (!mappedwalletTypes) {
//         toast.error("Invalid wallet type selected");
//         setOrderPlacing(false);
//         return;
//       }

//       let availableAmount = 0;
//       switch (mappedwalletTypes) {
//         case "SELF_LOADED":
//           availableAmount = availableSelf;
//           break;
//         case "COMPANY_LOADED":
//           availableAmount = availableCompany;
//           break;
//         case "CASHBACK":
//           availableAmount = availableCashback;
//           break;
//         default:
//           availableAmount = availableBalance;
//       }

//       if (availableAmount < grandTotal) {
//         toast.error(`Insufficient ${selectedwalletTypes} balance. Available: ₹${availableAmount.toFixed(2)}, Required: ₹${grandTotal.toFixed(2)}`);
//         setOrderPlacing(false);
//         return;
//       }

//       let response;

//       if (scheduledOrderDetails?.isScheduled) {
//         const [hour, minute] = scheduledOrderDetails.time.split(":");

//         const schedulePayload = {
//           cartId: cartId,
//           date: scheduledOrderDetails.date,
//           time: {
//             hour: parseInt(hour),
//             minute: parseInt(minute),
//             second: 0,
//             nano: 0
//           },
//           schedule: true,
//           paymentMethod: "Maamaas_Wallet",
//           razorpayPaymentId: "N/A",
//           razorpayOrderId: "N/A",
//           walletTypes: [mappedwalletTypes],
//           totalAmount: grandTotal,
//           userId: parseInt(userId)
//         };

//         response = await axios.post(
//           `https://backend.maamaas.com/food/api/orders/shedule/order/${cartId}`,
//           schedulePayload,
//           {
//             params: { userId: parseInt(userId) },
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json"
//             }
//           }
//         );
//       } else {
//         response = await axios.post(
//           `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
//           null,
//           {
//             params: {
//               userId: parseInt(userId),
//               paymentMethod: "Maamaas_Wallet",
//               walletTypes: mappedwalletTypes,
//               amount: grandTotal,
//               razorpayPaymentId: "N/A",
//               razorpayOrderId: "N/A"
//             },
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json"
//             }
//           }
//         );
//       }

//       const newOrderId = response.data?.orderId || response.data?.id;

//       if (newOrderId) {
//         localStorage.setItem("orderId", newOrderId);
//         setOrderId(newOrderId);
//         setShowPaymentOptions(false);
//         setScheduledOrderDetails(null);
//         setScheduleDate("");
//         setScheduleTime("");
//         await fetchWalletData();

//         await fetchAndShowInvoiceInCart(newOrderId);
//         toast.success(`✅ Order placed successfully using ${selectedwalletTypes} wallet!`);
//       } else {
//         throw new Error("No order ID received from server");
//       }

//     } catch (error) {
//       console.error("Wallet Payment Error:", error);
//       toast.error(error.response?.data?.message || "Wallet payment failed");
//       setOrderPlacing(false);
//     }
//   };


//   const handleOnlinePayment = async (userId, token, cartId) => {
//     try {
//       setOrderPlacing(true);

//       // ✅ STEP 1: CLEAN AMOUNT
//       const amount = grandTotal;
//       const amountInPaise = grandTotal;

//       console.log("Rupees:", amount);
//       console.log("Paise:", amountInPaise);

//       // ✅ STEP 2: LOAD RAZORPAY
//       const isLoaded = await loadRazorpayScript();
//       if (!isLoaded) throw new Error("Razorpay SDK failed to load");

//       // ✅ STEP 3: CREATE ORDER (SEND PAISE ONLY)
//       const orderRes = await axios.post(
//         "https://backend.maamaas.com/food/api/payments/create-order/user",
//         {
//           amount: amountInPaise, // 🔥 FIXED
//           currency: "INR",
//           receipt: `order_${Date.now()}`,
//           userId: parseInt(userId),
//           cartId: cartId,
//           isScheduled: scheduledOrderDetails?.isScheduled || false,
//           scheduleDate: scheduledOrderDetails?.date,
//           scheduleTime: scheduledOrderDetails?.time
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json"
//           }
//         }
//       );

//       const razorpayOrderId = orderRes.data?.id || orderRes.data?.orderId;
//       if (!razorpayOrderId) throw new Error("Failed to create Razorpay order");

//       // ✅ STEP 4: RAZORPAY OPTIONS
//       const options = {
//         key: "rzp_live_RU5whSMu9rPV7s",
//         amount: amountInPaise, // 🔥 MUST BE PAISE
//         currency: "INR",
//         name: "Maamaas Foods",
//         description: `Pay ₹${amount.toFixed(2)} for Cart ${cartId}`,
//         order_id: razorpayOrderId,

//         handler: async function (response) {
//           try {
//             const {
//               razorpay_payment_id: paymentId,
//               razorpay_order_id: rzpOrderId,
//               razorpay_signature: signature
//             } = response;

//             // ✅ STEP 5: CAPTURE PAYMENT (PAISE)
//             await axios.post(
//               "https://backend.maamaas.com/food/api/payments/capture",
//               {
//                 paymentId,
//                 orderId: rzpOrderId,
//                 amount: amountInPaise, // 🔥 FIXED
//                 signature
//               },
//               {
//                 headers: {
//                   Authorization: `Bearer ${token}`,
//                   "Content-Type": "application/json"
//                 }
//               }
//             );

//             let orderResponse;

//             // ✅ STEP 6: CREATE ORDER AFTER PAYMENT
//             if (scheduledOrderDetails?.isScheduled) {
//               const [hour, minute] = scheduledOrderDetails.time.split(":");

//               const scheduleData = {
//                 cartId: cartId,
//                 date: scheduledOrderDetails.date,
//                 time: {
//                   hour: parseInt(hour),
//                   minute: parseInt(minute),
//                   second: 0,
//                   nano: 0
//                 },
//                 schedule: true,
//                 paymentMethod: "Online_Payment",
//                 razorpayPaymentId: paymentId,
//                 razorpayOrderId: rzpOrderId,
//                 walletTypes: [],
//                 totalAmount: amount, // UI/DB RUPEES ok
//                 userId: parseInt(userId)
//               };

//               orderResponse = await axios.post(
//                 `https://backend.maamaas.com/food/api/orders/shedule/order/${cartId}`,
//                 scheduleData,
//                 {
//                   params: { userId: parseInt(userId) },
//                   headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                   }
//                 }
//               );

//             } else {
//               orderResponse = await axios.post(
//                 `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
//                 null,
//                 {
//                   params: {
//                     userId: parseInt(userId),
//                     paymentMethod: "Online_Payment",
//                     amount: amount, // UI OK in rupees
//                     razorpayPaymentId: paymentId,
//                     razorpayOrderId: rzpOrderId
//                   },
//                   headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                   }
//                 }
//               );
//             }

//             const newOrderId = orderResponse.data?.orderId;

//             if (newOrderId) {
//               localStorage.setItem("orderId", newOrderId);
//               setOrderId(newOrderId);

//               setShowPaymentOptions(false);
//               setScheduledOrderDetails(null);
//               setScheduleDate("");
//               setScheduleTime("");

//               await fetchAndShowInvoiceInCart(newOrderId);

//               toast.success(
//                 `Payment successful! Paid ₹${amount.toFixed(2)}`
//               );
//             }

//           } catch (err) {
//             console.error("Payment handler error:", err);
//             toast.error("Payment successful but order creation failed.");
//           } finally {
//             setOrderPlacing(false);
//           }
//         },

//         modal: {
//           ondismiss: () => {
//             setOrderPlacing(false);
//             toast.info("Payment cancelled");
//           }
//         },

//         prefill: {
//           name: userProfile?.name || "",
//           email: userProfile?.email || "",
//           contact: userProfile?.phoneNumber || ""
//         },

//         theme: { color: "#ee6521" }
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();

//     } catch (err) {
//       console.error("Payment Error:", err);
//       toast.error("Payment failed: " + err.message);
//       setOrderPlacing(false);
//     }
//   };

//   // ==================== PLACE ORDER ====================
//   const handlePlaceOrder = async () => {
//     if (orderType === 'DELIVERY' && !selectedAddressObj) {
//       toast.error("Please select a delivery address");
//       setShowAddressPopup(true);
//       setOrderPlacing(false);
//       return;
//     }

//     if (!selectedPaymentMethod) {
//       toast.error("Please select a payment method");
//       return;
//     }
//     if (selectedPaymentMethod === "Maamaas_Wallet" && !selectedwalletTypes) {
//       toast.error("Please select a wallet type");
//       return;
//     }

//     const { userId, token, cartId } = getAuthVars();
//     if (!userId || !token) {
//       toast.error("User not logged in. Please login again.");
//       return;
//     }
//     if (!cartId) {
//       toast.error("Cart is empty. Please add items to cart.");
//       return;
//     }
//     if (cartItems.length === 0) {
//       toast.error("Your cart is empty.");
//       return;
//     }

//     setOrderPlacing(true);
//     try {
//       if (selectedPaymentMethod === "Online_Payment") {
//         await handleOnlinePayment(userId, token, cartId);
//       } else if (selectedPaymentMethod === "Maamaas_Wallet") {
//         await handleWalletPayment(userId, token, cartId);
//       } else if (selectedPaymentMethod === "Cash") {
//         await handleCashPayment(userId, token, cartId);
//       }
//     } catch (error) {
//       console.error("Order placement error:", error);
//       toast.error(error.response?.data?.message || error.message || "Failed to place order.");
//       setOrderPlacing(false);
//     }
//   };

//   // Helper functions for components
//   const handleCategorySelect = (cat) => {
//     setSelectedCategory(cat.dishId);   // ✅ FIX
//     setIsVegSelected(false);
//     setIsNonVegSelected(false);
//   };

//   const clearFilters = () => {
//     setSearchTerm("");
//     setIsVegSelected(false);
//     setIsNonVegSelected(false);
//     setSelectedCategory("ALL");
//     setDiscountFilter("Offers");
//     setCouponFilter("Coupons");
//   };

//   const handleAddressSelect = async (addr) => {
//     console.log("Address selected:", addr); // Debug log

//     // Set the selected address object
//     setSelectedAddressObj(addr);
//     setAddress(addr.address || addr.addressLine || "");

//     // Save to localStorage
//     localStorage.setItem("lastDeliveryAddress", JSON.stringify(addr));

//     // Close the popup
//     setShowAddressPopup(false);

//     // Confirm the address with the cart
//     await confirmAddress(addr);
//   };

//   const handleAddressAdded = async (newAddress) => {
//     console.log("New address added:", newAddress); // Debug log

//     if (!newAddress || !newAddress.id) {
//       console.error("Invalid new address:", newAddress);
//       toast.error("Failed to add address");
//       return;
//     }

//     // Set the selected address object to the new address
//     setSelectedAddressObj(newAddress);
//     setAddress(newAddress.address || newAddress.addressLine || "");

//     // Save to localStorage
//     localStorage.setItem("lastDeliveryAddress", JSON.stringify(newAddress));

//     // Close the popup
//     setShowAddressPopup(false);

//     // Wait a bit for state to update then confirm address
//     setTimeout(async () => {
//       await confirmAddress(newAddress);
//     }, 100);
//   };
//   const handleShowGSTPopup = async () => {
//     const { userId, token } = getAuthVars();
//     if (!userId || !token) {
//       toast.error("Please login to view GST details");
//       return;
//     }

//     try {
//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/cart/get/user/without-seating?userId=${userId}`,
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
//       );

//       const data = response.data;
//       let gstData;

//       if (Array.isArray(data) && data.length > 0) {
//         const firstItem = data[0];
//         gstData = {
//           serviceChargeGst: firstItem.serviceChargeGst || 0,
//           platformChargeGst: firstItem.platformChargeGst || 0,
//           cgst: firstItem.cgst || 0,
//           sgst: firstItem.sgst || 0,
//           gstPercentage: firstItem.gstPercentage || 18
//         };
//       } else if (data && typeof data === 'object') {
//         gstData = {
//           serviceChargeGst: data.serviceChargeGst || 0,
//           platformChargeGst: data.platformChargeGst || 0,
//           cgst: data.cgst || 0,
//           sgst: data.sgst || 0,
//           gstPercentage: data.gstPercentage || 18
//         };
//       } else {
//         gstData = {
//           serviceChargeGst: 0,
//           platformChargeGst: 0,
//           cgst: 0,
//           sgst: 0,
//           gstPercentage: 18
//         };
//       }

//       setGstBreakdownData(gstData);
//       setShowGstPopup(true);
//     } catch (err) {
//       console.error("Error fetching GST data:", err);
//       toast.error("Failed to fetch GST details");
//     }
//   };

//   const handleApplyCouponWrapper = () => {
//     navigate("/Notifications");
//   };

//   // Window resize handler
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//       if (window.innerWidth > 768) {
//         setIsCartPanelOpen(false);
//       }
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Fetch categories
//   useEffect(() => {
//   const fetchSubCategories = async () => {
//     const userId = localStorage.getItem("userId");
//     const vendorId = localStorage.getItem("vendorId");

//     if (!userId || !vendorId) return;

//     setCategoriesLoading(true);

//     try {
//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/dish/getby/vendor/user/dishes?vendorId=${vendorId}&userId=${userId}`
//       );

//       const data = Array.isArray(response.data) ? response.data : [];

//       // Sirf Sub Categories (Category ke niche wali)
//       const subCategoryData = data.filter((item) => item.parentId === 1);

//       setSubCategories(subCategoryData);

//       console.log("Sub Categories:", subCategoryData);
//     } catch (error) {
//       console.error("Error fetching sub categories:", error);
//       setSubCategories([]);
//     } finally {
//       setCategoriesLoading(false);
//     }
//   };

//   fetchSubCategories();
// }, []);

//   const buildCategoryTree = (data) => {
//     const map = new Map();

//     data.forEach((item) => {
//       const isParent = !item.parentId || item.parentId === 0;

//       if (isParent) {
//         map.set(item.dishId, {
//           ...item,
//           subCategories: []
//         });
//       }
//     });

//     data.forEach((item) => {
//       const isChild = item.parentId && item.parentId !== 0;

//       if (isChild && map.has(Number(item.parentId))) {
//         map.get(Number(item.parentId)).subCategories.push(item);
//       }
//     });

//     return Array.from(map.values());
//   };

//   // Fetch dishes
//   useEffect(() => {
//   const fetchData = async () => {
//     const { token, userId } = getAuthVars();
//     const vendorId = localStorage.getItem("vendorId");

//     if (!vendorId || !token || !userId) {
//       setError(new Error("vendorId, userId or authToken missing"));
//       setLoading(false);
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await fetch(
//         `https://backend.maamaas.com/food/api/dish/getby/vendor/user/dishes?vendorId=${vendorId}&userId=${userId}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP Error: ${response.status}`);
//       }

//       const result = await response.json();
//       const dishData = Array.isArray(result) ? result : result.data || [];

//       // Store complete response
//       setAllDishes(dishData);

//       // Sub Categories (parentId = 1)
//       const subCategoryList = dishData.filter(
//         (item) =>
//           item.parentId === 1 &&
//           item.menuStatus === "Enable"
//       );

//       setSubCategories(subCategoryList);

//       // Actual Dishes (parentId > 1)
//       const dishList = dishData.filter(
//         (item) =>
//           item.parentId > 1 &&
//           item.menuStatus === "Enable"
//       );

//       setDishes(dishList);
//       setFilteredDishes(dishList);

//       console.log("All Data:", dishData);
//       console.log("Sub Categories:", subCategoryList);
//       console.log("Dishes:", dishList);

//     } catch (error) {
//       console.error(error);
//       setError(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchData();
//   fetchCartDetails();
//   fetchWalletData();
// }, [cartRefresh]);

//   // Filter effect
//   useEffect(() => {
//     if (!Array.isArray(allDishes)) return;

//     let filtered = [...allDishes];

//     // STEP 1: CATEGORY FILTER
//     if (selectedCategory && selectedCategory !== "ALL") {
//       filtered = filtered.filter(
//         item => Number(item.parentId) === Number(selectedCategory)
//       );
//     }





//     // STEP 2: SEARCH FILTER
//     const searchValue = searchTerm?.toLowerCase().trim() || "";
//     if (searchValue) {
//       filtered = filtered.filter(
//         item =>
//           item?.dishName &&
//           item.dishName.toLowerCase().includes(searchValue)
//       );
//     }

//     // STEP 3: VEG / NON-VEG FILTER
//     if (isVegSelected) {
//       filtered = filtered.filter(item => item?.tag === "Veg");
//     } else if (isNonVegSelected) {
//       filtered = filtered.filter(item => item?.tag === "Non_Veg");
//     }

//     // STEP 4: STATUS FILTER
//     filtered = filtered.filter(item => item?.menuStatus === "Enable");

//     setFilteredDishes(filtered);
//     setDishes(filtered);
//   }, [
//     selectedCategory,
//     searchTerm,
//     isVegSelected,
//     isNonVegSelected,
//     allDishes,
//     categories
//   ]);

//   useEffect(() => {
//     fetchWalletData();
//   }, []);

//   useEffect(() => {
//     if (showPaymentOptions) {
//       fetchWalletData();
//     }
//   }, [showPaymentOptions]);

//   const getTotalItems = () => cartItems.reduce((t, i) => t + (quantities[i.itemId] || i.quantity || 1), 0);
//   const cartItemsCount = getTotalItems();

//   if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>;
//   if (error) return <div style={{ padding: '40px', textAlign: 'center', color: 'red' }}>Error: {error.message}</div>;

//   return (



//     <div style={{ marginTop: '90px', display: 'flex', gap: '20px' }} className='menuiteams-data'>


//       {/* MAIN CONTENT */}
//       <div style={{ flex: 1, minWidth: 0 }}>
//         <Vendorbanner />
//         <FilterBar
//           searchTerm={searchTerm}
//           setSearchTerm={setSearchTerm}
//           isVegSelected={isVegSelected}
//           setIsVegSelected={setIsVegSelected}
//           isNonVegSelected={isNonVegSelected}
//           setIsNonVegSelected={setIsNonVegSelected}
//           selectedCategory={selectedCategory}
//           setSelectedCategory={setSelectedCategory}
//           discountFilter={discountFilter}
//           setDiscountFilter={setDiscountFilter}
//           couponFilter={couponFilter}
//           setCouponFilter={setCouponFilter}
//           onClearFilters={clearFilters}
//         />

//         <CategorySection
//           subCategories={subCategories}
//           categoriesLoading={categoriesLoading}
//           selectedCategory={selectedCategory}
//           onCategoryClick={handleCategorySelect}
//         />

//         <div className="offers-containers" style={{
//           padding: '0 16px',
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
//           gap: '20px'
//         }}>
//           {filteredDishes.map((item) => (
//   <DishCard
//   key={item.dishId}
//   item={item}
//   cartItems={cartItems}
//   quantities={quantities}
//   favorites={favorites}
//   activeTooltip={activeTooltip}
//   onToggleTooltip={handleToggleTooltip}
//   onAddToFavorites={handleAddToFavorites}
//   onIncreaseQuantity={increaseQuantity}
//   onDecreaseQuantity={decreaseQuantity}
//   onAddToCart={addToCart}
//   getAuthVars={getAuthVars}
//   setShowLogin={setShowLogin}
// />
// ))}
//         </div>
//       </div>

//       {/* DESKTOP CART SIDEBAR */}
//       {!isMobile && (
//         <CartSidebar
//   cartItems={cartItems}
//   quantities={quantities}
//   cartItemsCount={cartItemsCount}
//   onClearCart={handleClearCart}
//   onDecrementQuantity={decrementQuantity}
//   onIncrementQuantity={incrementQuantity}
//   subTotal={subTotal}
//   gstTotal={gstTotal}
//   platformCharges={platformCharges}
//   packingCharges={packingCharges}
//   deliveryCharges={deliveryCharges}
//   discountAmount={discountAmount}
//   grandTotal={grandTotal}
//   appliedCoupon={appliedCoupon}
//   onRemoveCoupon={handleRemoveCoupon}
//   onApplyCoupon={handleApplyCouponWrapper}
//   orderType={orderType}
//   setOrderType={setOrderType}
//   selectedAddressObj={selectedAddressObj}
//   onShowAddressPopup={setShowAddressPopup}
//   showPaymentOptions={showPaymentOptions}
//   setShowPaymentOptions={setShowPaymentOptions}
//   selectedPaymentMethod={selectedPaymentMethod}
//   setSelectedPaymentMethod={setSelectedPaymentMethod}
//   selectedwalletTypes={selectedwalletTypes}
//   setSelectedwalletTypes={setSelectedwalletTypes}
//   onPlaceOrder={handlePlaceOrder}
//   orderPlacing={orderPlacing}
//   onOpenScheduleModal={openScheduleModal}
//   availableBalance={availableBalance}
//   availableSelf={availableSelf}
//   availableCompany={availableCompany}
//   availableCashback={availableCashback}
//   onShowGST={handleShowGSTPopup}
//   fetchCartData={fetchCartDetails}
//    updateAddonQuantity={updateAddonQuantity} // ✅ Add this
//   cartData={{ cartId: localStorage.getItem("cartId") }}  // ✅ Add this
// />
//       )}

//       {/* MOBILE CART DRAWER */}
//       <MobileCartDrawer
//         isOpen={isMobile && isCartPanelOpen}
//         onClose={() => setIsCartPanelOpen(false)}
//         cartItems={cartItems}
//         quantities={quantities}
//         completedOrderData={completedOrderData}
//         cartItemsCount={cartItemsCount}
//         onClearCart={handleClearCart}
//         onDecrementQuantity={decrementQuantity}
//         onIncrementQuantity={incrementQuantity}
//         onResetAfterOrder={resetAfterOrder}
//         subTotal={subTotal}
//         gstTotal={gstTotal}
//         platformCharges={platformCharges}
//         packingCharges={packingCharges}
//         deliveryCharges={deliveryCharges}
//         discountAmount={discountAmount}
//         grandTotal={grandTotal}
//         appliedCoupon={appliedCoupon}
//         onRemoveCoupon={handleRemoveCoupon}
//         onApplyCoupon={handleApplyCouponWrapper}
//         orderType={orderType}
//         setOrderType={setOrderType}
//         selectedAddressObj={selectedAddressObj}
//         onShowAddressPopup={setShowAddressPopup}
//         showPaymentOptions={showPaymentOptions}
//         setShowPaymentOptions={setShowPaymentOptions}
//         selectedPaymentMethod={selectedPaymentMethod}
//         setSelectedPaymentMethod={setSelectedPaymentMethod}
//         selectedwalletTypes={selectedwalletTypes}
//         setSelectedwalletTypes={setSelectedwalletTypes}
//         onPlaceOrder={handlePlaceOrder}
//         orderPlacing={orderPlacing}
//         onOpenScheduleModal={openScheduleModal}
//         availableBalance={availableBalance}
//         availableSelf={availableSelf}
//         availableCompany={availableCompany}
//         availableCashback={availableCashback}
//         onShowGST={handleShowGSTPopup}
//       />

//       {/* FLOATING CART BUTTON FOR MOBILE */}
//       {isMobile && cartItemsCount > 0 && !completedOrderData && (
//         <button
//           onClick={() => setIsCartPanelOpen(true)}
//           style={{
//             position: 'fixed',
//             bottom: '80px',
//             right: '20px',
//             background: '#ee6521',
//             color: '#fff',
//             border: 'none',
//             borderRadius: '50px',
//             padding: '14px 24px',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '10px',
//             zIndex: 100,
//             boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
//             cursor: 'pointer',
//             fontSize: '16px',
//             fontWeight: 'bold'
//           }}
//         >
//           <ShoppingCart />
//           <span>{cartItemsCount}</span>
//         </button>
//       )}

//       {/* MODALS */}
//       <AddressPopup
//         isOpen={showAddressPopup}
//         onClose={() => setShowAddressPopup(false)}
//         addresses={addresses}
//         selectedAddressObj={selectedAddressObj}
//         onAddressSelect={handleAddressSelect}
//         onAddressAdded={handleAddressAdded}
//         fetchAddresses={fetchAddresses}
//       />

//       <GstPopup
//         isOpen={showGstPopup}
//         onClose={() => setShowGstPopup(false)}
//         gstBreakdownData={gstBreakdownData}
//       />

//       <ScheduleOrderModal
//         isOpen={isScheduleModalOpen}
//         onClose={() => {
//           setIsScheduleModalOpen(false);
//           setScheduleDate("");
//           setScheduleTime("");
//         }}
//         scheduleDate={scheduleDate}
//         setScheduleDate={setScheduleDate}
//         scheduleTime={scheduleTime}
//         setScheduleTime={setScheduleTime}
//         onConfirm={handleScheduleConfirm}
//       />

//       <InvoicePopup
//         isOpen={showInvoicePopup}
//         onClose={() => {
//           setShowInvoicePopup(false);
//           resetAfterOrder();
//         }}
//         orderData={completedOrderData}
//       />


// <Dialog
//     open={openAddonPopup}
//     onClose={() => setOpenAddonPopup(false)}
//     fullWidth
//     maxWidth="sm"
// >

//     <DialogTitle>
//         {selectedDish?.dishName}
//     </DialogTitle>

//     <DialogContent>

//         {selectedDish?.addons?.map((addon) => (

//             <FormControlLabel
//                 key={addon.addonId}
//                 control={
//                     <Checkbox
//                         checked={selectedAddons.some(
//                             a => a.addonId === addon.addonId
//                         )}
//                         onChange={(e) => {

//                             if (e.target.checked) {

//                                 setSelectedAddons([
//                                     ...selectedAddons,
//                                     addon
//                                 ]);

//                             } else {

//                                 setSelectedAddons(
//                                     selectedAddons.filter(
//                                         a => a.addonId !== addon.addonId
//                                     )
//                                 );

//                             }

//                         }}
//                     />
//                 }
//                 label={`${addon.addonName} ₹${addon.addonPrice}`}
//             />

//         ))}

//     </DialogContent>

//     <DialogActions>

//         <Button
//             onClick={() => setOpenAddonPopup(false)}
//         >
//             Cancel
//         </Button>

//         <Button
//             variant="contained"
//             onClick={() =>
//                 addToCart(
//                     selectedDish,
//                     1,
//                     false,
//                     selectedAddons
//                 )
//             }
//         >
//             Add To Cart
//         </Button>

//     </DialogActions>

// </Dialog>
//       <style>{`
//         @media (max-width: 768px) { 
//           .offers-containers { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; } 
//         }
//         @media (max-width: 480px) { 
//           .offers-containers { grid-template-columns: repeat(1, 1fr) !important; } 
//         }
//       `}</style>
//     </div>

//   );
// };

// export default MenuItemsTable;